export default __webpack_public_path__ + "static/media/hardships.974cc2ac.svg";